import videoHeroPoster from "./assets/figma/winners/couple-scene.webp";

const SUCHARD_HERO_LOOP_URL = "https://www.suchard.es/assets/videos/10s_Suchard.mp4";

const demoSecondaryPrizes = Array.from({ length: 50 }, (_, index) => (
  Object.freeze({
    number: `DEMO-${String(index + 1).padStart(5, "0")}`,
    series: `LOREM-${(index % 5) + 1}`,
  })
));

export const demoCampaignContent = Object.freeze({
  youtube: Object.freeze({
    header: Object.freeze({
      youtubeId: "JNLKEblx2_o",
      title: "Sigamos compartiendo el sabor de la Navidad",
      autoplay: false,
      loop: false,
      posterUrl: videoHeroPoster,
      backgroundVideoUrl: SUCHARD_HERO_LOOP_URL,
    }),
    slider: Object.freeze({
      title: "Escucha nuestro coro",
      videos: Object.freeze([
        Object.freeze({
          //https://www.youtube.com/shorts/ivUvRCv-jNI
          youtubeId: "ivUvRCv-jNI",
          title: "Ejemplo 1 · Suchard 2025 · Son todas Navidades",
          posterUrl: "https://i.ytimg.com/vi/QYUZ4cUzEZw/maxresdefault.jpg",
        })
      ]),      
      /*videos: Object.freeze([
        Object.freeze({
          youtubeId: "QYUZ4cUzEZw",
          title: "Ejemplo 1 · Suchard 2025 · Son todas Navidades",
          posterUrl: "https://i.ytimg.com/vi/QYUZ4cUzEZw/maxresdefault.jpg",
        }),
        Object.freeze({
          youtubeId: "JNLKEblx2_o",
          title: "Ejemplo 2 · Suchard 2025 · Son todas Navidades",
          posterUrl: "https://i.ytimg.com/vi/JNLKEblx2_o/maxresdefault.jpg",
        }),
      ]),*/
    }),
    stories: Object.freeze({
      title: "Por si te has perdido nuestras nuevas historias",
      videos: Object.freeze([
        Object.freeze({
          youtubeId: "JNLKEblx2_o",
          title: "El sabor de todas las Navidades · Suchard",
          posterUrl: "https://i.ytimg.com/vi/JNLKEblx2_o/maxresdefault.jpg",
        }),
        Object.freeze({
          youtubeId: "QYUZ4cUzEZw",
          title: "Una historia de Navidad · Suchard",
          posterUrl: "https://i.ytimg.com/vi/QYUZ4cUzEZw/maxresdefault.jpg",
        }),
      ]),
    }),
  }),
  winners: Object.freeze({
    demoNotice: "Datos de prueba: no son resultados reales.",
    referencePlaceholder: true,
    introCopy: "Revisa que el número y la serie de tu tableta Suchard Clásico coincidan con el número ganador y descubre si este año el gran premio es para ti.",
    grandPrizeTitle: "Primer Premio: 100.000€",
    grandPrize: Object.freeze({
      number: "DEMO-00000",
      series: "LOREM",
    }),
    secondaryTitle: "50 Segundos Premios de 1.000€",
    secondaryCopy: "Comprueba si la combinación de número y serie de tu envoltorio aparece entre los siguientes números premiados o descarga el listado oficial (PDF).",
    secondaryPrizes: Object.freeze(demoSecondaryPrizes),
    officialPdfUrl: null,
  }),
});
